import { render, staticRenderFns } from "./ERP-export-video-modal.vue?vue&type=template&id=2b7d679a&scoped=true"
import script from "./ERP-export-video-modal.vue?vue&type=script&lang=js"
export * from "./ERP-export-video-modal.vue?vue&type=script&lang=js"
import style0 from "./ERP-export-video-modal.vue?vue&type=style&index=0&id=2b7d679a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7d679a",
  null
  
)

export default component.exports